var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeopleCancelledVideoCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1666 6.98463V6.42841C14.1666 5.11381 13.0288 4.1665 11.7777 4.1665H3.22214C1.97102 4.1665 0.833252 5.11381 0.833252 6.42841V13.5713C0.833252 14.8859 1.97102 15.8332 3.22214 15.8332H11.7777C13.0288 15.8332 14.1666 14.8859 14.1666 13.5713V13.0144L16.7548 14.3083C17.0088 14.4352 17.2912 14.4952 17.5749 14.4824C17.8586 14.4696 18.1343 14.3846 18.3759 14.2353C18.6175 14.086 18.817 13.8775 18.9553 13.6295C19.0937 13.3815 19.1664 13.1023 19.1666 12.8183V7.1812C19.1664 6.89721 19.0937 6.61753 18.9553 6.36954C18.817 6.12154 18.6175 5.91302 18.3759 5.76376C18.1343 5.6145 17.8586 5.52944 17.5749 5.51666C17.2912 5.50388 17.009 5.56381 16.7549 5.69075L14.1666 6.98463ZM8.33325 7.49984C8.33325 7.0396 7.96016 6.6665 7.49992 6.6665C7.03968 6.6665 6.66659 7.0396 6.66659 7.49984V10.488L6.42251 10.2439C6.09707 9.91848 5.56943 9.91848 5.244 10.2439C4.91856 10.5694 4.91856 11.097 5.244 11.4224L6.91066 13.0891C7.2361 13.4145 7.76374 13.4145 8.08917 13.0891L9.75584 11.4224C10.0813 11.097 10.0813 10.5694 9.75584 10.2439C9.4304 9.91848 8.90277 9.91848 8.57733 10.2439L8.33325 10.488V7.49984Z",
    fill: "#FF3A5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleCancelledVideoCall);
export default __webpack_public_path__ + "static/media/people-cancelled-video-call.e3731499f9de27a1fa565c104313366a.svg";
export { ForwardRef as ReactComponent };